import { useTranslation } from 'react-i18next';
import {
  StepperCard,
  EStepperCardState,
  type IStepperCardItemData,
} from '@kognitos/lattice';
import { EnvironmentType } from '../schemas';

/** Step key constants for controlled StepperCard */
const STEP_KEY_DRAFT = 'draft';
const STEP_KEY_PUBLISHED = 'published';

export interface IEnvironmentStatusProps {
  activeEnvironment: EnvironmentType;
  onStepClick?: (stepKey: string) => void;
}

/**
 * Displays environment configuration progress as stepper cards.
 * Shows Test (step 1) and Production (step 2) environments with
 * selected, default, or completed states.
 */
export function EnvironmentStatus({
  activeEnvironment,
  onStepClick,
}: IEnvironmentStatusProps) {
  const { t: tIntegrations } = useTranslation('integrations');

  const isDraftCompleted = activeEnvironment === EnvironmentType.Published;

  const currentKey =
    activeEnvironment === EnvironmentType.Published
      ? STEP_KEY_PUBLISHED
      : STEP_KEY_DRAFT;

  const steps: IStepperCardItemData[] = [
    {
      key: STEP_KEY_DRAFT,
      title: tIntegrations(
        `integrations.connections.environment.${EnvironmentType.Draft}`,
      ),
      ...(isDraftCompleted && { state: EStepperCardState.COMPLETED }),
    },
    {
      key: STEP_KEY_PUBLISHED,
      title: tIntegrations(
        `integrations.connections.environment.${EnvironmentType.Published}`,
      ),
    },
  ];

  return (
    <StepperCard
      direction="row"
      steps={steps}
      current={currentKey}
      onStepClick={onStepClick}
      className="w-full"
    />
  );
}
